import { render, staticRenderFns } from "./LotteryForm.vue?vue&type=template&id=620e9834&scoped=true"
import script from "./LotteryForm.vue?vue&type=script&lang=js"
export * from "./LotteryForm.vue?vue&type=script&lang=js"
import style0 from "./LotteryForm.vue?vue&type=style&index=0&id=620e9834&prod&lang=scss"
import style1 from "./LotteryForm.vue?vue&type=style&index=1&id=620e9834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620e9834",
  null
  
)

export default component.exports